import { render, staticRenderFns } from "./electricityPanel.vue?vue&type=template&id=64b4adbd&scoped=true&"
import script from "./electricityPanel.vue?vue&type=script&lang=js&"
export * from "./electricityPanel.vue?vue&type=script&lang=js&"
import style0 from "./electricityPanel.vue?vue&type=style&index=0&id=64b4adbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4adbd",
  null
  
)

export default component.exports